import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {ObjectGroupResponse, ObjectGroupsResponse} from "../models/response"

export const objectGroupApi = {
    getObjectGroups(params?: GetParamsType & ObjectGroupsFilterQuery): Promise<CommonResponse<ObjectGroupsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`ObjectGroup${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getObjectGroup(params: GetSingleParamsType): Promise<CommonResponse<ObjectGroupResponse>> {
        const {id, controller} = params
        return instance.get(`ObjectGroup/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createObjectGroup(form: CreateObjectGroupType): Promise<CommonResponse<ObjectGroupResponse>> {
        const {controller, ...rest} = form
        return instance.post(`ObjectGroup`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeObjectGroup(form: ChangeObjectGroupType): Promise<CommonResponse<ObjectGroupResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`ObjectGroup/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteObjectGroup(id: number): Promise<CommonResponse<any>> {
        return instance.delete(`ObjectGroup/${id}`).then((res: AxiosResponse) => res.data)
    },
}

export type ObjectGroupsFilterQuery = {
    idCompany?: number
    search?: string
}

export type CreateObjectGroupType = {
    name: string
    idCompany: number
    active: boolean
    description: string
    attributes: string
    timeOffset: number
} & BaseRequestParams

export type ChangeObjectGroupType = {
    id: number
} & CreateObjectGroupType